(() => {

    const gauge = document.querySelector('.swiper-gauge');
    const gaugeLength = 100 / gauge.dataset.length;

    gsap.registerPlugin(ScrollTrigger);

    // **************** scrollTrigger ****************
    ScrollTrigger.saveStyles('.sc-gallery__list');

    ScrollTrigger.matchMedia({
        '(min-width: 751px)': () => {
            // .sc-gallery
            gsap.to('.sc-gallery__list', {
                xPercent: -100,
                x: () => {
                    // -100%만큼 좌측으로 보내서 아예 없앤 후 보여질 만큼만 우측으로 다시 당김
                    // 0.864583 -> .sc-gallery의 여백인 13.5417vw 제외한 부분을 당기기 위한 작업
                    return document.body.offsetWidth * 0.864583;
                },
                ease: 'none',
                scrollTrigger: {
                    trigger: '.sc-gallery',
                    start: '11% top',
                    end: '89% bottom',
                    scrub: 2,
                    invalidateOnRefresh: true,
                    // invalidateOnRefresh : 반응형에 따라 값 재계산 해주는 옵션
                    onUpdate: (self) => {
                        gsap.to('.swiper-gauge', {
                            '--gauge': (self.progress * (100 - gaugeLength)) + gaugeLength,
                        });
                    },
                },
            });
        },
        all: () => {
            // .sc-artisan
            ScrollTrigger.create({
                trigger: '.sc-artisan figure',
                start: '15% 100%',
                onEnter: () => {
                    document.querySelector('.sc-artisan .artisan').className += ' active';
                    // 진입시 클래스 추가. active 클래스 여부에 따라 모션 작동
                },
                once: true, // 한 번만 실행
            });
        },
    });

    // **************** parallax ****************

    const encounterBox = document.querySelectorAll('.sc-encounter__item .i-box');
    const encounterImg = document.querySelectorAll('.sc-encounter__item .i-box img');

    new setParallax('.sc-gukbin__item .i-box', '.sc-gukbin__item .i-box img', '-15%', '15%');
    new setParallax(encounterBox[0], encounterImg[0], '-7%', '7%');
    new setParallax(encounterBox[1], encounterImg[1], '-15%', '15%');
    new setParallax(encounterBox[2], encounterImg[2], '-10%', '10%');

    // **************** swiper ****************
    const breakPoint = window.matchMedia('(max-width: 750px)');

    // 1. .sc-gallery
    let gallerySwiper = null;

    const swiperSetting = (boolean) => {
        if (boolean) {
            // 스와이퍼 셋팅
            gallerySwiper = new Swiper('.sc-gallery .swiper', {
                slidesPerView: 1,
                spaceBetween: 16,
                navigation: {
                    prevEl: '.sc-gallery .swiper-btn--prev',
                    nextEl: '.sc-gallery .swiper-btn--next',
                },
                scrollbar: {
                    el: '.sc-gallery .swiper-gauge',
                    draggable: true,
                },
            });
        } else if (!boolean && gallerySwiper) {
            // 스와이퍼 삭제
            gallerySwiper.destroy(true, true);
            gallerySwiper = null;
        }
    };

    breakPoint.matches && swiperSetting(true); // 모바일 로드 시 셋팅

    breakPoint.addEventListener('change', (e) => {
        // pc->mo 스와이퍼 셋팅, mo->pc 스와이퍼 삭제
        e.matches ? swiperSetting(true) : swiperSetting(false);
    });

})();
